var _spliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/splice");

var _indexOfInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

(function () {
  if (typeof window.Element === "undefined" || "classList" in document.documentElement) return;

  var prototype = Array.prototype,
      push = prototype.push,
      splice = _spliceInstanceProperty(prototype),
      join = prototype.join;

  function DOMTokenList(el) {
    this.el = el; // The className needs to be trimmed and split on whitespace
    // to retrieve a list of classes.

    var classes = el.className.replace(/^\s+|\s+$/g, '').split(/\s+/);

    for (var i = 0; i < classes.length; i++) {
      push.call(this, classes[i]);
    }
  }

  ;
  DOMTokenList.prototype = {
    add: function add(token) {
      if (this.contains(token)) return;
      push.call(this, token);
      this.el.className = this.toString();
    },
    contains: function contains(token) {
      var _context;

      return _indexOfInstanceProperty(_context = this.el.className).call(_context, token) != -1;
    },
    item: function item(index) {
      return this[index] || null;
    },
    remove: function remove(token) {
      if (!this.contains(token)) return;

      for (var i = 0; i < this.length; i++) {
        if (this[i] == token) break;
      }

      splice.call(this, i, 1);
      this.el.className = this.toString();
    },
    toString: function toString() {
      return join.call(this, ' ');
    },
    toggle: function toggle(token) {
      if (!this.contains(token)) {
        this.add(token);
      } else {
        this.remove(token);
      }

      return this.contains(token);
    }
  };
  window.DOMTokenList = DOMTokenList;

  function defineElementGetter(obj, prop, getter) {
    if (_Object$defineProperty) {
      _Object$defineProperty(obj, prop, {
        get: getter
      });
    } else {
      obj.__defineGetter__(prop, getter);
    }
  }

  defineElementGetter(Element.prototype, 'classList', function () {
    return new DOMTokenList(this);
  });
})();